export const globalPageCount = 20;
